// @flow

import stores from 'stores';

export default () => {
  return stores.aclStore.getCurrentRole();
};
